import React from 'react';
import './App.css';
import Root from './Pages/Root';
import { SnackbarProvider } from 'notistack';
import { ProgramProvider, SettingsProvider, VideoProvider } from './Context'
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, createMuiTheme} from '@material-ui/core/styles';

function App() {

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: '#f6a519',
        light: '#f6a519',
        dark: '#f6a519',
      }, 
      secondary: {
        main: "#7EB6DD",
        light: '#7EB6DD',
        dark: '#7EB6DD'
      }
    }
  })


  return (
    <SnackbarProvider preventDuplicate>
      <Router>
        <SettingsProvider>
          <ProgramProvider>
            <VideoProvider>
            <ThemeProvider theme={theme}>
                <Root />
              </ThemeProvider>
            </VideoProvider>
          </ProgramProvider>
        </SettingsProvider>
      </Router>
    </SnackbarProvider>
  );
}

export default App;
